import React from 'react';
import { CYAN } from '../const';

const SVG = ({ style = {}, color = CYAN, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g transform="rotate(-45 50 50)">
      <defs>
        <clipPath id="clip">
          <rect x="27" y="0" width="46" height="47" />
          <rect x="27" y="53" width="46" height="47" />
        </clipPath>
      </defs>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <circle cx="50" cy="50" r="19" fill="transparent" stroke={color} strokeWidth={8} clipPath="url(#clip)" />
      <path d="M 66,22 L 72,28 72,46 56,46 49,39 66,39" fill={color} />
      <path d="M 33,77 L 27,71 27,53 43,53 50,60 33,60" fill={color} />
    </g>
  </svg>
);

export default SVG;
